<template>
  <div
    class="sp-menu_cover"
    @click="hideMenuCover()"
    :class="isMenuOpen ? 'animated' : ''">

    <ul>
      <router-link :to="{name: 'Usages'}">
        <li>ご利用の流れ</li>
      </router-link>
      <router-link :to="{name: 'About'}">
        <li>フルーについて</li>
      </router-link>

      <template v-if="isLogin">
        <li v-if="isInMypage" @click="toggleMypagePcMenuCover">
          メニュー
        </li>
        <router-link v-else :to="{name: 'MypageTop'}">
          <li>マイページ</li>
        </router-link>
        <li @click="logout()">
          ログアウト
        </li>
      </template>

      <template v-else>
        <router-link :to="{ name: 'Login'}">
          <li>ログイン</li>
        </router-link>
        <li v-if="isLoginButNotVerified">
          <button @click="resendVerifyingEmail()">
            認証メール再送信
          </button>
        </li>
        <li v-else>
          <router-link :to="{ name: 'RegistrationUser'}">
            会員登録
          </router-link>
        </li>
      </template>

      <a target="_blank" href="https://corp.flew-createx.com/">
        <li><img class='base_image' src='@/assets/image/common/logo_flew_sm.png'></li>
      </a>
    </ul>
  </div>
</template>

<script>
  import store from "@/store";
  import {mapGetters} from "vuex";
  import animation from "@/assets/js/functions/_core/animation";
  import auth from "@/assets/js/functions/firebase/auth/auth";

  export default {
    name: "SpMenuCover",

    mixins: [animation, auth],

    props: {
      isInMypage: {
        type: Boolean,
      }
    },

    computed: {
      ...mapGetters({isLogin: 'auth/isLogin', isMenuOpen: 'cover/isMenuOpen', isLoginButNotVerified: 'auth/isLoginButNotVerified'}),
    },

    methods: {
      toggleMypagePcMenuCover() {
        store.dispatch('cover/toggleMypagePcMenuCover')
      },
      hideMenuCover() {
        if (!this.isMenuOpen) return;
        store.dispatch('cover/toggleMenuCover')
      },
    }
  }
</script>

<style lang="scss" scoped>
  .sp-menu_cover {
    @include cover;
    @extend .fade_in;

    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    > ul {
      li {
        font-size: $huge_font-size;
        border-bottom: 2px solid $secondary_color;
        margin: 4rem 0;
        padding-bottom: 0.5rem;

        > .base_image {
          height: 3.5rem;
        }
      }
    }
  }
</style>